<template>
	<div class="job-title">
		<div class="row" style="margin-bottom: 20px;">
			<div class="col-xl-6">研究领域管理</div>
			<div class="col-xl-6" style="display: flex;justify-content: flex-end;align-items: center;"><Breadcrumb></Breadcrumb></div>
		</div>

		<el-card>
			<div class="btn-wrap" style="margin-bottom: 20px;"><el-button type="primary" @click="openJobTitleDialog('add')">新增</el-button></div>
			<el-table
				:data="researchFieldList"
				style="width: 100%;margin-bottom: 20px;"
				row-key="id"
				border
				default-expand-all
				:tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
			>
				<el-table-column prop="name" label="研究领域"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button style="margin-right: 20px;" type="primary" @click="openJobTitleDialog('edit', scope.row)">修改</el-button>
						<el-popconfirm title="确定删除吗？" @confirm="confirmDel(scope.row.id)"><el-button slot="reference" type="danger">删除</el-button></el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
		</el-card>

		<!-- 新增或者修改研究领域 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false">
			<el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="父级目录" prop="parentId">
					<el-cascader v-model="form.parentId" :options="researchFieldList" :props="{ label: 'name', value: 'id',checkStrictly: true }"></el-cascader>
				</el-form-item>
				<el-form-item label="研究名称" prop="dictName">
					<el-input placeholder="请输入研究领域" v-model="form.dictName" clearable></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogCancel">取 消</el-button>
				<el-button type="primary" @click="confire">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
import { getPlatformInformationData, addPlatformInformationData, delPlatformInformationData, editPlatformInformationData } from '@/api/after/systemManagement.js';
export default {
	components: {
		Breadcrumb
	},
	data() {
		return {
			dialogTitle: '新增',
			dialogVisible: false,
			form: {
				dictName: '',
				dictTypeId: 6,
				parentId: 0,
				level: null
			},
			rules:{
				dictName:[{ required: true, message: '请输入研究领域', trigger: 'blur' }]
			},
			curEditDataId: 0,
			researchFieldList: []
		};
	},
	created() {
		this.getPlatformInformationData();
	},
	methods: {
		// 获取研究领域列表
		async getPlatformInformationData() {
			const res = await getPlatformInformationData(6);
			console.log('研究领域', res);
			if (res.code == 200) {
				this.researchFieldList = res.data;
			} else {
				this.$message.error(res.data);
			}
		},
		// 添加研究领域
		async addPlatformInformationData(data) {
			const res = await addPlatformInformationData(data);
			if (res.code == 200) {
				await this.getPlatformInformationData();
				this.dialogVisible = false;
			} else {
				this.$message.error(res.data);
			}
		},
		// 修改研究领域
		async editPlatformInformationData(data) {
			
			const res = await editPlatformInformationData(data);
			if (res.code == 200) {
				this.dialogVisible = false;
				this.form.dictName = '';
				this.getPlatformInformationData();
			} else {
				this.$message.error(res.data);
			}
		},
		// 删除研究领域
		async delPlatformInformationData(id) {
			const res = await delPlatformInformationData(id);
			if (res.code == 200) {
				this.getPlatformInformationData();
			} else {
				this.$message.error(res.msg);
			}
		},
		// 确认删除
		async confirmDel(id) {
			await this.delPlatformInformationData(id);
		},
		// 确定弹出框
		confire() {
			console.log(this.form);
				let form = JSON.parse(JSON.stringify(this.form))
				if (form.parentId) {
					form.parentId = form.parentId[form.parentId.length-1]
				}
				console.log(form);
			if (this.dialogTitle === '新增') {
				this.addPlatformInformationData(form);
			} else {
				form = {
					...form,
					id: this.curEditDataId
				};
				this.editPlatformInformationData(form);
			}
			this.$refs.ruleForm.resetFields()
		},
		// 打开弹出框
		openJobTitleDialog(type, data) {
			
			if (type === 'add') {
				this.dialogTitle = '新增';
			} else {
				if (data) {
					let arr = [data.parentId]
					function getAllParentId(id,data){
						for(let i=0;i<data.length;i++){
							if (id == data[i].id) {
								if (data[i].parentId != 0) {
									arr.unshift(data[i].parentId)
								}else{
									return
								}
							}else{
								if (data[i].children) {
									getAllParentId(id,data[i].children)
								}
							}
						}
					}
					getAllParentId(data.parentId, this.researchFieldList)
					this.dialogTitle = '修改';
					this.curEditDataId = data.id;
					this.form.dictName = data.name;
					this.form.parentId = arr
					console.log(this.form);
				}
			}
			this.dialogVisible = true;
		},
		// 取消对话框
		dialogCancel() {
			this.dialogVisible = false;
			this.form.dictName = '';
		}
	}
};
</script>

<style scoped></style>
